import {Box, Flex, Text, Title} from 'exsportia-components'
import {Formik} from 'formik'
import {DateTime} from 'luxon'
import {FC, useMemo, useState} from 'react'

import {Button} from '../../ui/components/button/button'
import {DOBPicker} from '../../ui/components/dob-picker/dob-picker'
import {PhoneLoginProgress} from '../../ui/components/phone-login-progress/phone-login-progress'
import {useLocale} from '../../utils/i18n'

type PhoneLoginDobStepProps = {
  onNext: (dob: string) => void
  onSkip: () => void
  onBack?: () => void
  initialDob?: string
}

export const PhoneLoginDobStep: FC<PhoneLoginDobStepProps> = ({onNext, onSkip, onBack, initialDob}) => {
  const {l} = useLocale()
  const [dob, setDobValue] = useState<DateTime | null>(initialDob ? DateTime.fromFormat(initialDob, 'dd/LL/yyyy') : null)

  const handleNext = () => {
    if (dob) {
      onNext(dob.toFormat('dd/LL/yyyy'))
    }
  }

  return (
    <Formik
      initialValues={{dob: ''}}
      onSubmit={(_values, _helpers) => {
        _helpers.setSubmitting(false)
      }}
    >
      <Box pb={'24px'}>
        <PhoneLoginProgress currentStep={2} />
        <Flex
          justifyContent='space-between'
          alignItems='center'
          mb='8px'
        >
          <Title
            text={l('dob')}
            styleType='h2'
          />
          <Button
            type='flat_short'
            onClick={onSkip}
          >
            {l('skip', {defaultMessage: 'Skip'})}
          </Button>
        </Flex>
        <Flex mb='16px'>
          <Text text={l('enter_your_dob', {caseAction: 'capitalize'})} />
        </Flex>

        <Box mb='16px' px='16px'>
          <DOBPicker
            value={dob}
            onChange={setDobValue}
          />
        </Box>

        <Flex mt='24px' gap='16px'>
          {onBack && (
            <Box style={{flex: 1}}>
              <Button
                type='secondary'
                onClick={onBack}
              >
                {l('back', {defaultMessage: 'Back', caseAction: 'capitalize'})}
              </Button>
            </Box>
          )}
          <Box style={{flex: 1}}>
            <Button
              onClick={handleNext}
              disabled={!dob}
            >
              {l('continue', {defaultMessage: 'Continue', caseAction: 'capitalize'})}
            </Button>
          </Box>
        </Flex>
      </Box>
    </Formik>
  )
}
